import { Component } from '@angular/core';

@Component({
    selector: 'app-send-info',
    templateUrl: 'send-info.component.html',
})
export class SendInfoComponent { }
